export { default } from './bmg-error-modal';
